import styled from "styled-components";

export const Container = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  overflow: auto; /* Adicione esta linha para controlar o overflow */
`;